import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { usePetitionDetails } from '../hooks/petitionDetails/petitionDetails';

export const HeadingContainer: React.FC = () => {
	const details = usePetitionDetails();
	return (
		<div className="py-6">
			<div>
				<Text
					as="h1"
					variant="heading"
					fontWeight="bold"
					data-qa="petition-title"
					className="text-left text-[40px] leading-[52px] break-words lg:text-[48px] lg:leading-[56px]"
				>
					{details.ask}
				</Text>
			</div>
		</div>
	);
};
